import { render, staticRenderFns } from "./AppLoginLoader.vue?vue&type=template&id=60369c2e&scoped=true"
import script from "./AppLoginLoader.vue?vue&type=script&lang=js"
export * from "./AppLoginLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60369c2e",
  null
  
)

export default component.exports